module.exports = __webpack_public_path__ + "img/643444d.jpg";